import React, { createContext, useContext, useState, useEffect } from 'react'

const CompanyAuthContext = createContext()

export const useCompanyAuth = () => {
  const context = useContext(CompanyAuthContext)
  if (!context) {
    throw new Error('useCompanyAuth must be used within CompanyAuthProvider')
  }
  return context
}

export const CompanyAuthProvider = ({ children }) => {
  const [accessToken, setAccessToken] = useState(localStorage.getItem('access_token'))
  const [companyId, setCompanyId] = useState(localStorage.getItem('company_id'))
  const [userInfo, setUserInfo] = useState(() => {
    const stored = localStorage.getItem('company_user_info')
    return stored ? JSON.parse(stored) : null
  })

  const login = (token, companyIdValue, userInfoValue) => {
    localStorage.setItem('access_token', token)
    localStorage.setItem('company_id', companyIdValue)
    localStorage.setItem('company_user_info', JSON.stringify(userInfoValue))
    setAccessToken(token)
    setCompanyId(companyIdValue)
    setUserInfo(userInfoValue)
  }

  const logout = () => {
    localStorage.removeItem('access_token')
    localStorage.removeItem('company_id')
    localStorage.removeItem('company_user_info')
    setAccessToken(null)
    setCompanyId(null)
    setUserInfo(null)
  }

  return (
    <CompanyAuthContext.Provider
      value={{
        accessToken,
        companyId,
        userInfo,
        login,
        logout,
        isAuthenticated: !!accessToken,
      }}
    >
      {children}
    </CompanyAuthContext.Provider>
  )
}

export default CompanyAuthContext
